export default __webpack_public_path__ + "static/media/label-blue.c36400e8.svg";